module.exports = __webpack_public_path__ + "img/beta_badge.6405b21d.svg";